<template>
    <div class="table-responsive" style="width: 100%">
        <table class="">
            <thead>
            <tr>
                <th v-for="header in dataHeaders">{{header}}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row,row_index) in dataRecords"
                :title="rowLengthInvalid(row)"
                :key="row_index">
                <template v-for="(cell, field) in row.record">
                    <TableCell
                            :rules="headers[field]"
                            :key="field"
                            :entry="row.record"
                            :cell_key="field"
                            :row_index="row_index"
                            :is_invalid="isInvalid(field,row.invalid)"
                            :title="getInvalidMessage(field,row.invalid)"
                            :target_focus="focus_on_cell(field,row_index)"
                            @set_invalid=""
                            @input="getInput"
                    ></TableCell>
                </template>
            </tr>
            </tbody>
        </table>
        <div>
            <BaseButton
                    @click="submit"
                    :cls="setDisabled()"
                    ref="save_button">{{button_title}}
            </BaseButton>
        </div>
    </div>
</template>

<script>
    import {_} from 'underscore';
    export default {
        name: "TableEditor",
        props: {
            headers: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            records: {
                type: Array,
                default: []
            },
            validate: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            submit_url: {
                type: String,
                default: null
            },
            submit_additional_params: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            button_title: {
                type: String,
                default: 'Submit'
            }
        },
        data() {
            return {
                targetInvalidCell: {},
                dataRecords: [],
                dataHeaders: [],
                submitting:false
            }
        },
        mounted() {
            this.dataRecords = this.records;
            this.buildHeaders();
        },
        computed:{

        },
        methods: {
            /**
             * Sets the submit button to disabled when there are invalid records
             * @returns {string|null}
             */
            setDisabled(){
                if(this.submitting === true){
                    return 'disabled'
                }
                for (let i = 0; i < this.dataRecords.length; i++) {
                    let record = this.dataRecords[i];
                    if(!_.isEmpty(record.invalid)){
                        return 'disabled';
                    }
                }
                return null;
            },
            focus_on_cell(item,row_number){
                if(this.targetInvalidCell.hasOwnProperty('item')){
                    if(this.targetInvalidCell.item === item && this.targetInvalidCell.row_number === row_number){
                        return true
                    }
                }
                return false;
            },
            submit() {
                let self = this,
                    axios_data = {
                        records: self.dataRecords,
                        headers: self.dataHeaders
                    };
                self.submitting = true;
                // merge additional params to data

                axios
                    .post(self.submit_url,
                        Object.assign(self.submit_additional_params, axios_data)
                    )
                    /**
                     * @param {Object} response
                     */
                    .then(function (response) {
                        if (response.data.hasOwnProperty('has_errors') && response.data.has_errors === false) {
                            self.$emit('complete', response.data);
                        } else {
                            self.dataRecords = response.data.invalid.data;
                            self.buildHeaders(true);
                        }
                    })
                    .catch(function (e) {
                        // catch error if any
                        console.error('events fetch', e);
                    })
                    .then(function () {
                        self.submitting = false;
                    });
            },
            rowLengthInvalid(row,) {
                if (row.invalid.hasOwnProperty('row_length')) {
                    return row.invalid.row_length
                }
                return false;
            },
            log() {
                console.log.apply(console, arguments)
            },
            buildHeaders(init) {
                if (init === true) {
                    this.dataHeaders = [];
                }
                for (let header in this.headers) {
                    this.dataHeaders.push(header);
                }
            },
            getInput(data) {
                this.checkValidation(data.cell_key, data.value, data.row_index);
            },
            checkValidation(field, value, index) {
                let self = this;

                let theField = field,
                    theValue = value,
                    theIndex = index,
                    axios_data = {
                        field: theField,
                        item: theValue
                    };
                if (!self.validate.hasOwnProperty('use')) {
                    return true;
                }
                axios
                    .post(self.validate.url, axios_data)
                    /**
                     * @param {Object} response
                     */
                    .then(function (response) {
                        // check if the field is already marked as invalid
                        if (self.dataRecords[theIndex].invalid.hasOwnProperty(theField)) {
                            delete self.dataRecords[theIndex].invalid[theField]
                        }
                        self.dataRecords[theIndex].record[theField] = theValue;
                        self.removeTargetFromCell();
                    })
                    .catch(function (e) {
                        // catch error if any
                        // update the invalid record
                        self.dataRecords[theIndex].invalid[theField] = e.response.data.record[theField];
                        self.dataRecords[theIndex].record[theField] = theValue;
                    })
                ;
            },
            removeTargetFromCell() {
                let invalidRecord = this.targetInvalidRecord();
                if (!invalidRecord.hasOwnProperty('item')) {
                    if(this.button_title !== ''){
                        this.$refs.save_button.$el.focus();
                    }else {
                        window.focus();
                        if (document.activeElement) {
                            document.activeElement.blur();
                        }
                    }

                } else {
                    this.targetInvalidCell = invalidRecord;
                }
            },
            targetInvalidRecord() {
                let self = this;

                for (let row_number = 0; row_number < self.dataRecords.length; row_number++) {
                    let record = self.dataRecords[row_number];
                    if (record.hasOwnProperty('invalid')) {
                        for (let item in record.invalid) {
                            return {
                                item: item,
                                row_number: row_number
                            }
                        }
                    }
                }
                return {};
            },
            /**
             * Checks if the field is valid
             */
            isInvalid(field, invalid) {
                return invalid.hasOwnProperty(field);
            },
            /**
             * Create the invalid message tooltip
             * @param field
             * @param invalid
             * @returns {*}
             */
            getInvalidMessage(field, invalid) {
                if (invalid.hasOwnProperty(field)) {
                    let msg = [];
                    for (let i = 0; i < invalid[field].length; i++) {
                        msg.push(invalid[field][i]);
                    }
                    return msg.join('\n ');
                }
            }
        }
    }
</script>

<style scoped>
    .cell {
        background: transparent;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/table/TableEditor.vue?8dda1124